import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { propTypeslocalization } from '../../../../../constants/Proptypes';
import { propTypesNavigation } from '../../Header.proptypes';

import Button, { ButtonAppearance } from '../../../../../../ui/Atoms/Button';

import { addTrackingParamsToUrl } from '../../../../../utils/trackingParams';

import { DocumentType } from '../../../../../constants/Enums';
import * as S from './NavBarButtons.styles';

export const NavBarButtons = ({
  document: navBarDocument,
  documentType,
  localization,
}) => {
  const {
    signin_label: signinLabel,
    signin_url: { url: signinLink, target: signinTarget } = {},
    signin_datatrack: signinDatatrack,
    signup_label: signupLabel,
    signup_url: { url: signupLink, target: signupTarget } = {},
    signup_datatrack: signupDatatrack,
  } = navBarDocument || '';

  const [urls, setUrls] = useState({
    signinLink,
    signupLink,
  });

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setUrls({
        signinLink: addTrackingParamsToUrl(signinLink),
        signupLink: addTrackingParamsToUrl(signupLink),
      });
    }, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    document.addEventListener('cookiechange', () => {
      setUrls({
        signinLink: addTrackingParamsToUrl(signinLink),
        signupLink: addTrackingParamsToUrl(signupLink),
      });
    });

    return () => {
      document.removeEventListener('cookiechange', () => {
        setUrls({
          signinLink: addTrackingParamsToUrl(signinLink),
          signupLink: addTrackingParamsToUrl(signupLink),
        });
      });
    };
  }, []);

  const { data: localizationData } = localization || {};
  const {
    share_event_label: shareEventLabel,
    share_event_link: { url: shareEventLink, target: shareEventTarget } = {},
  } = localizationData || '';

  if (documentType === 'event') {
    return (
      <S.ButtonWrapper isEvent={true}>
        <Button
          altText={shareEventLabel}
          link={shareEventLink}
          target={shareEventTarget}
        >
          {shareEventLabel}
        </Button>
      </S.ButtonWrapper>
    );
  } else {
    return (
      <S.ButtonWrapper hasMargin={documentType === 'blog'}>
        <Button
          altText={signinLabel}
          appearance={ButtonAppearance.OUTLINE}
          dataTrackAttribute={signinDatatrack}
          link={urls?.signinLink}
          target={signinTarget}
        >
          {signinLabel}
        </Button>
        <Button
          altText={signupLabel}
          dataTrackAttribute={signupDatatrack}
          link={urls?.signupLink}
          target={signupTarget}
        >
          {signupLabel}
        </Button>
      </S.ButtonWrapper>
    );
  }
};

NavBarButtons.propTypes = {
  /**
   * Navigation document data from Prismic.
   */
  document: PropTypes.shape(propTypesNavigation.data),
  /**
   * Prismic document type of the current page.
   */
  documentType: PropTypes.oneOf(Object.values(DocumentType)),
  /**
   * Prismic Localization document.
   */
  localization: PropTypes.shape(propTypeslocalization),
};
